module.exports = __webpack_public_path__ + "static/en-76f6cbce4f2fd4c2b0e5faeb7e3bb93c.png";